import rolePermissions from "./rolePermissions";

const hasPermission = (permission) => {
  const userRole = sessionStorage.getItem("role");
  const permissions = rolePermissions[userRole] || [];
  return permissions.includes(permission);
};
export default hasPermission;
